{
  "defaultTitle": "無法報到",
  "defaultMessage": "請與您的調度員確認資訊，或聯絡倉庫",
  "backToHomescreen": "返回首頁",
  "hideErrorLog": "隱藏錯誤記錄",
  "viewErrorLog": "檢視錯誤記錄",
  "errorLogMessageLabel": "訊息：",
  "errorLogStatusLabel": "狀態碼：",
  "unknown": "未知"
}
